import React from 'react';
import { Box, Typography } from '@mui/material';


const TestimonialSection: React.FC = () => {
  return (
    <Box sx={{
      bgcolor: '#FFF8E1',
      p: 2,
      borderRadius: '8px',
      border: '1px solid',
      borderColor: '#FFCC80',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        <Box>
          <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.primary' }}>
            "Seeing Luna's card every morning reminds me of her spirit."
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
            — Mark, CA
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialSection;
